import { ZIPTEAMS_API_BASE_URL } from "../../utils/constants";
import HttpClient from "../../utils/http-client";

export type IMeetCustomerSignIn = {
  room_id: string;
  participant_name: string;
  meet_passcode: string;
};

export type ICustomerConversationPayload = {
  customer_id: number;
  conversation_id: string;
  /** our chat id (utils/chatPersistence); one resumed chat spans several ElevenLabs conversations */
  chat_id?: string;
};

class Conversation {
  customerSignIn = (payload: IMeetCustomerSignIn) =>
    HttpClient.post(
      `${ZIPTEAMS_API_BASE_URL}/v1/conversation/signin/customer`,
      payload
    );

  syncCustomerConversation = (payload: ICustomerConversationPayload) =>
    HttpClient.post(
      `${ZIPTEAMS_API_BASE_URL}/v1/client/knowledge-layer/elevenlabs/link-conversation`,
      payload
    );
}

const ConversationService = new Conversation();
export default ConversationService;

// https://api.dev.zipteams.com/api/v1/conversation/signin/customer
